//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      expanded: false
    }
  },
  props: {
    imageUrl: String,
    caption: String,
    widthPercent: {
      type: Number,
      default: 50
    }
  }
}
